import { MQ_LARGE, MQ_MIDLARGE } from 'constants/mq';

export const DEFAULT_IMAGE_SOURCE_SIZES = [
  {
    media: MQ_MIDLARGE,
    layoutWidth: {
      value: 1148,
      units: 'px'
    }
  },
  {
    media: MQ_LARGE,
    layoutWidth: {
      value: 976,
      units: 'px'
    }
  },
  {
    layoutWidth: {
      value: 100,
      units: 'vw'
    }
  }
];

export const DEFAULT_PLACEMENT = 'interrupter';

/**
 * Determines a primary type for the ItemBundle
 * Currently defines primary type based on the first item
 *
 * @param {Array} items list of BundleItems
 * @returns {String} the primary type of items in the bundle
 */
export function getBundleType(items) {
  return items[0].type;
}
